import React from 'react'

function Icon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="18" height="18" rx="9" fill="#F59E0B" />
      <path
        d="M12.8548 12.1544C13.0484 12.348 13.0484 12.6621 12.8548 12.8556C12.6613 13.049 12.3482 13.0489 12.1546 12.8556L9.00034 9.70035L5.84506 12.8556C5.65151 13.0492 5.33745 13.0492 5.14389 12.8556C4.95049 12.662 4.95038 12.348 5.14389 12.1544L8.29917 8.99917L5.14487 5.84585C4.95151 5.65233 4.95151 5.33918 5.14487 5.14566C5.33843 4.9521 5.65248 4.9521 5.84604 5.14566L9.00034 8.29898L12.1537 5.14566C12.3472 4.95211 12.6613 4.9521 12.8548 5.14566C13.0481 5.33924 13.0483 5.65338 12.8548 5.84683L9.70151 9.00015L12.8548 12.1544Z"
        fill="white"
      />
    </svg>
  )
}

export default Icon
